import React from 'react';
import {
  ArrowDownward as ArrowDownwardIcon,
  ArrowUpward as ArrowUpwardIcon,
  SwapVert as SwapVertIcon,
} from '@mui/icons-material';
import {
  Box,
  IconButton,
  type SxProps,
  TableCell,
  TableHead,
  TableRow,
  type Theme,
  Tooltip,
} from '@mui/material';
import { getTaskSortTooltipTitle } from '../utils.ts';
import { SortDirection } from '../taskModels.ts';
import { TASKS_GUARANTEES_TABLE_COLUMNS } from '../constants.ts';
import { tasksPageStyles } from '../styles.ts';
import type { ITasksServiceTableHeadProps } from './types.ts';

const TasksServiceTableHead: React.FC<ITasksServiceTableHeadProps> = ({
  guaranteesDateSortDirection = SortDirection.Desc,
  onGuaranteesDateSortToggle,
}) => {
  const isGuaranteesDateSortActive = guaranteesDateSortDirection !== SortDirection.None;
  const dateSortIcon =
    guaranteesDateSortDirection === SortDirection.Asc ? (
      <ArrowUpwardIcon fontSize="small" />
    ) : guaranteesDateSortDirection === SortDirection.Desc ? (
      <ArrowDownwardIcon fontSize="small" />
    ) : (
      <SwapVertIcon fontSize="small" />
    );
  return (
    <TableHead sx={tasksPageStyles.tableHead}>
      <TableRow>
        {TASKS_GUARANTEES_TABLE_COLUMNS.map(({ align, headCellType, key, label }) => (
          <TableCell
            key={key}
            align={align}
            sx={
              [
                (theme) => tasksPageStyles.tableHeadCell(theme, headCellType),
                tasksPageStyles.tableCellSize[key],
              ] as SxProps<Theme>
            }
          >
            {key === 'deadline' ? (
              <Box sx={tasksPageStyles.tableHeaderFilter}>
                {label}
                <Tooltip
                  title={getTaskSortTooltipTitle(
                    isGuaranteesDateSortActive,
                    guaranteesDateSortDirection
                  )}
                >
                  <IconButton
                    size="small"
                    onClick={onGuaranteesDateSortToggle}
                    sx={tasksPageStyles.tableHeaderIconButton(isGuaranteesDateSortActive)}
                  >
                    {dateSortIcon}
                  </IconButton>
                </Tooltip>
              </Box>
            ) : (
              label
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default TasksServiceTableHead;
